export const addSponsorLead = `
mutation MyMutation($input: [AddSponsorLeadsInput]!) {
  addSponsorLeads(input: $input)
}`;

export const updateSponsorLead = `
mutation MyMutationCopy($input: [UpdateSponsorLeadsInput]!) {
  updateSponsorLeads(input: $input)
}`;

export const createUserSponsorMapping = `
mutation MyMutationCopy($input: UserSponsorMappingInput!) {
  createUserSponsorMapping(input: $input)
}`;

// export const addSponsorLeadIndividuals = `
// mutation MyMutationCopy($input: AddSponsorLeadInput!) {
//   addSponsorLead(input: $input)
// }`;

/* eslint-disable */
// this is an auto generated file. This will be overwritten

// export const createSponsors = /* GraphQL */ `
//   mutation CreateSponsors(
//     $input: CreateSponsorsInput!
//     $condition: ModelSponsorsConditionInput
//   ) {
//     createSponsors(input: $input, condition: $condition) {
//       id
//       eventId
//       sponsorName
//       sponsorEmail
//       leadsCount
//       sponsorCode
//       createdBy
//       updatedBy
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const updateSponsors = /* GraphQL */ `
//   mutation UpdateSponsors(
//     $input: UpdateSponsorsInput!
//     $condition: ModelSponsorsConditionInput
//   ) {
//     updateSponsors(input: $input, condition: $condition) {
//       id
//       eventId
//       sponsorName
//       sponsorEmail
//       leadsCount
//       sponsorCode
//       createdBy
//       updatedBy
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const deleteSponsors = /* GraphQL */ `
//   mutation DeleteSponsors(
//     $input: DeleteSponsorsInput!
//     $condition: ModelSponsorsConditionInput
//   ) {
//     deleteSponsors(input: $input, condition: $condition) {
//       id
//       eventId
//       sponsorName
//       sponsorEmail
//       leadsCount
//       sponsorCode
//       createdBy
//       updatedBy
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const createUserSponsorMapping = /* GraphQL */ `
//   mutation CreateUserSponsorMapping(
//     $input: CreateUserSponsorMappingInput!
//     $condition: ModelUserSponsorMappingConditionInput
//   ) {
//     createUserSponsorMapping(input: $input, condition: $condition) {
//       id
//       userId
//       eventId
//       leadsCount
//       sponsorCode
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//       owner
//     }
//   }
// `;
// export const updateUserSponsorMapping = /* GraphQL */ `
//   mutation UpdateUserSponsorMapping(
//     $input: UpdateUserSponsorMappingInput!
//     $condition: ModelUserSponsorMappingConditionInput
//   ) {
//     updateUserSponsorMapping(input: $input, condition: $condition) {
//       id
//       userId
//       eventId
//       leadsCount
//       sponsorCode
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//       owner
//     }
//   }
// `;
// export const deleteUserSponsorMapping = /* GraphQL */ `
//   mutation DeleteUserSponsorMapping(
//     $input: DeleteUserSponsorMappingInput!
//     $condition: ModelUserSponsorMappingConditionInput
//   ) {
//     deleteUserSponsorMapping(input: $input, condition: $condition) {
//       id
//       userId
//       eventId
//       leadsCount
//       sponsorCode
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//       owner
//     }
//   }
// `;
// export const createSponsorAppAuthManagement = /* GraphQL */ `
//   mutation CreateSponsorAppAuthManagement(
//     $input: CreateSponsorAppAuthManagementInput!
//     $condition: ModelSponsorAppAuthManagementConditionInput
//   ) {
//     createSponsorAppAuthManagement(input: $input, condition: $condition) {
//       id
//       token
//       expiryTime
//       sponsorKey
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const updateSponsorAppAuthManagement = /* GraphQL */ `
//   mutation UpdateSponsorAppAuthManagement(
//     $input: UpdateSponsorAppAuthManagementInput!
//     $condition: ModelSponsorAppAuthManagementConditionInput
//   ) {
//     updateSponsorAppAuthManagement(input: $input, condition: $condition) {
//       id
//       token
//       expiryTime
//       sponsorKey
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const deleteSponsorAppAuthManagement = /* GraphQL */ `
//   mutation DeleteSponsorAppAuthManagement(
//     $input: DeleteSponsorAppAuthManagementInput!
//     $condition: ModelSponsorAppAuthManagementConditionInput
//   ) {
//     deleteSponsorAppAuthManagement(input: $input, condition: $condition) {
//       id
//       token
//       expiryTime
//       sponsorKey
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const createSponsorLeads = /* GraphQL */ `
//   mutation CreateSponsorLeads(
//     $input: CreateSponsorLeadsInput!
//     $condition: ModelSponsorLeadsConditionInput
//   ) {
//     createSponsorLeads(input: $input, condition: $condition) {
//       id
//       eventId
//       sponsorCode
//       bookingId
//       name
//       emailId
//       phoneNumber
//       designation
//       organisation
//       comment
//       scannedBy
//       createdAt
//       status
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const updateSponsorLeads = /* GraphQL */ `
//   mutation UpdateSponsorLeads(
//     $input: UpdateSponsorLeadsInput!
//     $condition: ModelSponsorLeadsConditionInput
//   ) {
//     updateSponsorLeads(input: $input, condition: $condition) {
//       id
//       eventId
//       sponsorCode
//       bookingId
//       name
//       emailId
//       phoneNumber
//       designation
//       organisation
//       comment
//       scannedBy
//       createdAt
//       status
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const deleteSponsorLeads = /* GraphQL */ `
//   mutation DeleteSponsorLeads(
//     $input: DeleteSponsorLeadsInput!
//     $condition: ModelSponsorLeadsConditionInput
//   ) {
//     deleteSponsorLeads(input: $input, condition: $condition) {
//       id
//       eventId
//       sponsorCode
//       bookingId
//       name
//       emailId
//       phoneNumber
//       designation
//       organisation
//       comment
//       scannedBy
//       createdAt
//       status
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
